module.exports = __webpack_public_path__ + "img/title_1.398560c3.png";